export enum FormSectionDatahooks {
  Main = 'form-section-main',
  EmptyState = 'form-section-empty-state',
}
